import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import React from "react";

import { ErrorSeverity, useErrorHandler } from "../../hooks/useErrorHandler";
import { GEO_BLOCKING_ERROR_MESSAGE } from "../../util/constants";
import {
  ButtonContainer,
  IconContainer,
  Message,
  StyledDialog,
  StyledPublicOffIcon,
  Title,
} from "./GeoBlockedModal.elements";

const getErrorReferenceId = (error?: string) => {
  if (!error?.endsWith(")")) {
    return undefined;
  }

  const referenceStartIndex = error.lastIndexOf("(");
  if (referenceStartIndex === -1) {
    return undefined;
  }

  return error.slice(referenceStartIndex + 1, -1);
};

export function GeoBlockedModal(): React.ReactElement | null {
  const { error } = useErrorHandler(ErrorSeverity.MEDIUM);

  // Derive open state directly from error - no need for useState
  const isGeoBlocked = typeof error === "string" && error.includes(GEO_BLOCKING_ERROR_MESSAGE);
  const errorReferenceId = typeof error === "string" ? getErrorReferenceId(error) : undefined;
  const supportReferenceId = errorReferenceId && !/^\d+$/.test(errorReferenceId) ? errorReferenceId : undefined;

  if (!isGeoBlocked) {
    return null;
  }

  const handleReturnToLibrary = () => {
    window.location.href = "/";
  };

  return (
    <StyledDialog open={isGeoBlocked} disableEscapeKeyDown>
      <DialogContent sx={{ padding: 0 }}>
        <IconContainer>
          <StyledPublicOffIcon />
        </IconContainer>

        <Title variant="h5">Content Not Available</Title>

        <Message variant="body1">
          {"This course is not available in your region "}
          <br />
          due to geographic restrictions.
        </Message>
        {supportReferenceId ? <Message variant="body2">Reference ID: {supportReferenceId}</Message> : null}

        <ButtonContainer>
          <Button variant="contained" color="primary" onClick={handleReturnToLibrary}>
            Return to Library
          </Button>
        </ButtonContainer>
      </DialogContent>
    </StyledDialog>
  );
}
